customElements.whenDefined('custom-accordion').then(() => {
  if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

  document.querySelectorAll('.header__inline-menu summary[data-salut-href]').forEach((summary) => {
    const url = summary.dataset.salutHref;
    if (!url || url === '#') return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      window.location.href = url;
    });

    summary.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        window.location.href = url;
      }
    });
  });

  const OPEN_DELAY = 70;
  const CLOSE_DELAY = 220;
  const EXIT_DURATION = 130;

  document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
    let timer = null;

    menu.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      menu.classList.remove('is-opening');
      requestAnimationFrame(() => menu.classList.add('is-opening'));
      timer = setTimeout(() => menu.classList.remove('is-opening'), 220);
    });
  });

  document.querySelectorAll('.header__inline-menu .header__submenu').forEach((submenu) => {
    let openTimer = null;
    let closeTimer = null;
    let current = null;

    const hide = (accordion) => {
      const row = accordion.parentElement;
      row.classList.add('is-closing');
      setTimeout(() => {
        row.classList.remove('is-closing');
        accordion.close(true);
      }, EXIT_DURATION);
    };

    const show = (accordion) => {
      if (current === accordion) return;
      if (current) hide(current);
      current = accordion;
      const row = accordion.parentElement;
      row.classList.remove('is-closing', 'is-opening');
      accordion.open(true);

      const panel = accordion.querySelector('.custom-accordion__panel');
      panel.classList.remove('custom-accordion__panel--flipped');
      if (panel.getBoundingClientRect().right > document.documentElement.clientWidth) {
        panel.classList.add('custom-accordion__panel--flipped');
      }

      requestAnimationFrame(() => row.classList.add('is-opening'));
      setTimeout(() => row.classList.remove('is-opening'), 220);
    };

    submenu.querySelectorAll(':scope > li > custom-accordion').forEach((accordion) => {
      const row = accordion.parentElement;

      row.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        if (current) {
          openTimer = setTimeout(() => show(accordion), OPEN_DELAY);
        } else {
          show(accordion);
        }
      });
    });

    submenu.addEventListener('mouseleave', () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => {
        if (current) hide(current);
        current = null;
      }, CLOSE_DELAY);
    });

    submenu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
  });
});
